import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const EngagementMetrics = ({ blog }) => {
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(blog?.popularity || 0);

  const handleLike = () => {
    if (!liked) {
      setLiked(true);
      setLikeCount(prev => prev + 1);
    } else {
      setLiked(false);
      setLikeCount(prev => prev - 1);
    }
  };

  return (
    <div className="mt-12 pt-8 border-t border-border">
      {/* Engagement Actions */}
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <Button
            variant={liked ? 'default' : 'outline'}
            size="sm"
            onClick={handleLike}
            className="gap-2"
          >
            <Icon name="Heart" size={18} fill={liked ? 'currentColor' : 'none'} />
            <span>{likeCount} Likes</span>
          </Button>
          <Button variant="outline" size="sm" className="gap-2">
            <Icon name="MessageCircle" size={18} />
            <span>{blog?.commentCount || 0} Comments</span>
          </Button>
          <Button variant="outline" size="sm" className="gap-2">
            <Icon name="Bookmark" size={18} />
            <span>Save</span>
          </Button>
        </div>
        <Link to="/blog-posts">
          <Button variant="ghost" iconName="ArrowLeft" iconPosition="left">
            Back to Blog
          </Button>
        </Link>
      </div>

      {/* Social Proof */}
      <div className="bg-muted/50 rounded-lg p-6">
        <div className="flex flex-wrap items-center gap-6 text-sm">
          <div className="flex items-center gap-2">
            <Icon name="Eye" size={18} color="var(--color-muted-foreground)" />
            <span className="text-foreground font-medium">{blog?.popularity || 0}</span>
            <span className="text-muted-foreground">views</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Heart" size={18} color="var(--color-muted-foreground)" />
            <span className="text-foreground font-medium">{likeCount}</span>
            <span className="text-muted-foreground">likes</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="MessageCircle" size={18} color="var(--color-muted-foreground)" />
            <span className="text-foreground font-medium">{blog?.commentCount || 0}</span>
            <span className="text-muted-foreground">comments</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Share2" size={18} color="var(--color-muted-foreground)" />
            <span className="text-foreground font-medium">{Math.floor((blog?.popularity || 0) * 0.15)}</span>
            <span className="text-muted-foreground">shares</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EngagementMetrics;